<template>
  <div class="flex-col detail-Info">
    <div class="complete-button">
      <input type="button"
        :value="$t('complete')"
        class="no-border"
        @click="completeClick">
    </div>
    <div class="flex-row center-info">
      <van-icon name="checked"
        size="30px"
        color="#D04a02"
        style="padding-right: 2rem"></van-icon>
      <div class="flex-col">
        <span class="success-info">{{ successInfo }}</span>
        <span class="tickes-info">{{tickets}} {{$t('addRelationshipTickes')}}</span>
      </div>
    </div>
    <div class="buttom-info">
      <van-button plain
        type="info"
        color="#ea4d10"
        @click="completeClick">{{$t('viewMyRelationship')}}</van-button>
    </div>
  </div>
</template>

<script>
import webService from "../../network/webService";
import _ from 'lodash';
import commonjs from "../../common/common";
import commonStyle from '../../styles/common.scss';
import {
  Toast
} from 'vant';
export default {
  name: 'AddRelationshipSuccess',
  components: {
    Toast
  },
  data () {
    return {
      tickets: 3,
      successInfo: '添加关系成功！'
    };
  },
  created () {
    console.log('AddRelationshipSuccess')
    if (this.$route.query.isEdit == "false") {
      if (this.$route.query.Passed == 0)
        this.successInfo = "感谢您的添加！此条关系会在管理员审核完成后发布。 ";
      else
        this.successInfo = "添加关系成功。 ";
    }
    if (this.$route.query.isEdit == "true") {
      this.successInfo = "编辑关系成功";
      if (this.$route.query.Passed == 0) {
        this.successInfo = "编辑关系成功,待管理员审核";
      }
    }
    this.goHomeView();
  },
  methods: {
    goHomeView () {
      const TIME_COUNT = 3;
      if (!this.timer) {
        this.tickets = TIME_COUNT;
        this.timer = setInterval(() => {
          if (this.tickets > 0 && this.tickets <= TIME_COUNT) {
            this.tickets--;
          } else {
            clearInterval(this.timer);
            this.timer = null;
            this.$router.push({ path: '/home/myRelationshipList/' + Math.random() * 1000000, });
          }
        }, 1000)
      }
    },
    completeClick () {
      clearInterval(this.timer);
      this.$router.push({ path: '/home/myRelationshipList/' + Math.random() * 1000000, });
    }
  },
};
</script>


<style lang="scss" scoped>
.detail-Info {
  height: calc(100% - 50px);
}
.complete-button {
  text-align: right;
  padding: 20px;
}
.no-border {
  border: none;
  background-color: white;
}
.center-info {
  justify-content: center;
  padding: 1rem;
}
.buttom-info {
  padding: 2rem;
  text-align: center;
}
.success-info {
  font-weight: bold;
  font-size: 18px;
  color: #464646;
  text-align: center;
}
.tickes-info {
  font-size: 15px;
  color: #7d7d7d;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/add/AddRelationshipSuccess.vue